import './OnboardingInputs.css';
import React, { useEffect, useState } from 'react';
import ExternalUserScreen from './ExternalUserScreen';
import { useNavigate } from 'react-router-dom';
import SaveToApi from '../utils/SaveToApi';
import { getAuthHeader } from '../utils/tokenManager';

const apiUrl = process.env.REACT_APP_DJANGO_API_URL;

const DetailsApproval = ({ selectedPayments, selectedContactInfo, selectedSocialMedia, customUrl, account_id, user_id, userDisplay, languageSetting, selectedProducts }) => {
    const navigate = useNavigate();
    const [userStats, setUserStats] = useState({
        maxUsers: 0,
        currentUserCount: 0,
        error: null,
        loading: true
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchUserStats = async () => {
            try {
                const response = await fetch(`${apiUrl}/api/${account_id}/user_stats/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        ...getAuthHeader(),
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch user stats');
                }

                const data = await response.json();
                setUserStats({
                    maxUsers: data.max_users,
                    currentUserCount: data.current_user_count,
                    error: null,
                    loading: false
                });
            } catch (error) {
                setUserStats(prev => ({
                    ...prev,
                    error: error.message,
                    loading: false
                }));
            }
        };

        fetchUserStats();
    }, [account_id]);
    
    // Save function to send data to API
    const handleSave = async () => {
        try {
            setLoading(true);
            const result = await SaveToApi({ 
                selectedPayments, 
                selectedContactInfo, 
                selectedSocialMedia, 
                customUrl, 
                account_id,
                user_id,
                userDisplay: userDisplay 
            });
            alert('Details saved and approved!');
            setLoading(false);
            // Redirect to the /account_id/me URL after successful save
            navigate(`/${account_id}/me`);
            return true;
        } catch (error) {
            console.error('Error:', error);
            alert('Error: Could not save details.');
            setLoading(false);
            return false;
        }
    };

    const handleAddAnotherUser = async () => {
        window.location.href = `/${account_id}/onboarding?user_id=${userStats.currentUserCount+1}`;
    };

    return (
        <>
            <h2>{languageSetting === "ENGLISH" ? "Review Your Details And Test Your Links." : "Revisa Tus Detalles Y Prueba Tus Enlaces."}</h2>
            <ExternalUserScreen 
                selectedPayments={selectedPayments} 
                selectedContactInfo={selectedContactInfo} 
                selectedSocialMedia={selectedSocialMedia}
                userDisplay={userDisplay}
                actual_uuid={account_id}
                selectedProducts={selectedProducts}
            />

            <><br />
            <div className="save-center-container">
                <button 
                    className="option-button" 
                    onClick={handleSave}
                    disabled={loading}
                >
                    {loading ? 'Saving...' : 'Save & Approve'}
                </button>
                {!userStats.loading && !userStats.error && userStats.currentUserCount < userStats.maxUsers && (
                    <button
                        className="option-button add-user-button" 
                        onClick={handleAddAnotherUser}
                        disabled={loading}
                    >
                        Add Another User
                    </button>
                )}
            </div>
            {userStats.loading ? (
                <div>Loading user stats...</div>
            ) : userStats.error ? (
                <div className="error-message">Error loading user stats: {userStats.error}</div>
            ) : (
                <div className="user-stats">
                    <br />
                    <p>Account Users: {userStats.currentUserCount} / {userStats.maxUsers}</p>
                </div>
            )}</>
        </>
    );
};

export default DetailsApproval;
